import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui-css'
import 'jquery-mask-plugin';

export default class DatePicker {

    static init(seletor: JQuery<HTMLElement>, options?: JQueryUI.DatepickerOptions) {
        seletor.mask('00/00/0000');

        seletor.datepicker({
            autoSize: true,
            dateFormat: "dd/mm/yy",
            dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
            dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            onSelect: function (date, datepicker) {
                $(this).trigger('input');
            },
            ...options
        });
    }
}
